/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_WebsiteInputs */

const en_homepage_features_upload_website = /** @type {(inputs: Homepage_Features_Upload_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website URL`)
};

const es_homepage_features_upload_website = /** @type {(inputs: Homepage_Features_Upload_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de sitio web`)
};

/**
* | output |
* | --- |
* | "Website URL" |
*
* @param {Homepage_Features_Upload_WebsiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_website = /** @type {((inputs?: Homepage_Features_Upload_WebsiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_WebsiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_website(inputs)
	return en_homepage_features_upload_website(inputs)
});